<template>
    <div class="page-one home-page">
		<div class="logo"></div>
		<div class="note">{{text}}</div>
    </div>
</template>

<script>
import { PRELOADER } from '../modules/utils'
import { WEIXIN } from '../modules/weixin';
export default {
    computed: {
        gotUserInfo() {
            return this.$store.state.gotUserInfo;
        },
        userData() {
            return this.$store.state.userData;
        }
    },
    data() {
        return {
            text: '加载中',
            textIndex: 0
        }
    },
    mounted() {
        this.initAnim();
        setTimeout(function() {
            this.initDom();
        }.bind(this), 20);
        
        var me = this;
        PRELOADER.loadReportAudio(function() {
            me.checkLoginData();
        });
        // setTimeout(function() {
        //     this.checkLoginData();
        // }.bind(this), 1000);
    },
    methods: {
        initDom() {
            this.$el.style.height = innerHeight+'px';
        },
        initAnim() {
            var me = this;
            function ani() {
                if(me.textIndex < 3) {
                    me.textIndex++;
                    me.text = me.text+'.';
                }else {
                    me.textIndex = 0;
                    me.text = '加载中';
                }
                setTimeout(ani, 300);
            }
            ani();
        },
        checkLoginData() {
            var me = this;
            if(this.gotUserInfo && this.userData) {
                if(this.userData.isnewuser == 1) {
                    localStorage.removeItem('h5_thj_free');
                    localStorage.removeItem('h5_thj_dicount');
                    PRELOADER.loadIndexImageList(function() {
                        me.$router.replace('/index');
                    })
                }else if(this.userData.isnewuser == 0) {
                    PRELOADER.loadReportImageList(function() {
                        me.$store.dispatch('user/getUserHomePageData', {
                            cb: function() {
                                me.$router.replace('/report');
                            },
                            failCb: function() {
                                me.$router.replace('/index');
                            }
                        });
                    });
                }
            }else {
                // PRELOADER.loadReportImageList(function() {
                //     me.$store.dispatch('user/getUserHomePageData', {
                //         cb: function() {
                //             me.$router.replace('/report');
                //         },
                //         failCb: function() {
                //             me.$router.replace('/index');
                //         }
                //     });
                // }); 
                // return;
                PRELOADER.loadIndexImageList(function() {
                    me.$router.replace('/index');
                })
            }
        }
    }
}
</script>

<style scoped>
.home-page {
    padding-top: 30vh;
}
.logo {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    border: solid 2px #FDB4B4;
    border-radius: 50%;
    
    background-image: url('http://m1.2048.net/duoniu/images_rabbit/logo.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
}
.note {
    padding-top: 10px;
    text-align: center;
    font-size: 0.85rem;
    color: #FDB4B4;
}
</style>